// extracted by mini-css-extract-plugin
export default {"header":"styles_header__0YpD3","headerButtons":"styles_headerButtons__HRcpB","button":"styles_button__26czl"};